import React, { useRef, useState } from 'react';

import * as style from './ArticleExpandableReview.module.scss';

const ArticleExpandableReview = (props) => {
  const { children, expandedText, collapsedText } = props;

  const [isExpanded, setIsExpanded] = useState(false);
  const childrenContainerRef = useRef();

  const scrollBack = () => {
    document.getElementsByTagName('html')[0].scrollBy({
      top: -childrenContainerRef.current.offsetHeight + 100,
      behavior: 'smooth',
    });
  };

  const toggleExpanded = () => {
    setIsExpanded((prevState) => {
      if (prevState) {
        scrollBack();
      }
      return !prevState;
    });
  };

  return (
    <div className={style.expandableReview}>
      <div
        className={`${style.childrenContainer} ${
          isExpanded ? null : style.collapsed
        }`}
        ref={childrenContainerRef}
      >
        {children}
      </div>
      <div className={style.expandTextButton} onClick={toggleExpanded}>
        {isExpanded ? expandedText : collapsedText}
      </div>
      <div
        className={`${style.edgeSmoothener} ${
          isExpanded ? style.invisible : null
        }`}
      />
    </div>
  );
};

export default ArticleExpandableReview;
